import { useState, useEffect, useContext, useMemo } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import { Link, useLocation } from 'react-router-dom';
import API from "../../utils/API";
import './style.css'
import UtilityBillGraph1 from '../../components/UtilityBillGraph1';
import Loader from '../../components/Loader';
import moment from 'moment';
import UtilityBillGraph2 from '../../components/UtilityBillGraph2';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import AccordionMultipleSelect from '../../components/AccordionMultipleSelect';
import { withRetry504 } from '../../utils/utils';

const UtilityReport = () => {

    const [submit, setSubmit] = useState(false);
    const context = useContext(AppContext);
    const [buildingOptions, setBuildingOptions] = useState(false)
    const [buildingsInfo, setBuildingsInfo] = useState(false)
    const [selectedBuildings, setSelectedBuildings] = useState([]);
    const [start, setStart] = useState(moment().startOf('month').subtract(1, 'months').format('YYYY-MM-DD'))
    const [end, setEnd] = useState(moment().endOf('month').format('YYYY-MM-DD'))
    const location = useLocation();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    useEffect(() => {
        if (!context.getUserInfo) return;
        let buildings = context.getUserInfo.buildings;
        let tempClients = {};
        for (let item of buildings) {
            tempClients[item.client_name] = tempClients[item.client_name] || [];
            tempClients[item.client_name].push(item);
        }
        tempClients = Object.keys(tempClients).map(e => ({ title: e, content: tempClients[e] }));
        tempClients.sort(function (a, b) {
            var titleA = a.title.toUpperCase();
            var titleB = b.title.toUpperCase();
            if (titleA < titleB) return -1;
            if (titleA > titleB) return 1;
            return 0;
        });
        setBuildingOptions(tempClients);
    }, [context.getUserInfo]);

    useEffect(() => {
        let newBuilding = queryParams.get('building')


        if (!context.getUserInfo) return
        if (queryParams.size !== 0) {
            let building = context.getUserInfo.buildings.find(e => e.building_id === newBuilding)
            if (building && !selectedBuildings.includes(building.building_id)) {
                setSelectedBuildings(prev => [...prev, building.building_id])
                if (newBuilding !== context.getBuilding) context.setBuilding(newBuilding)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams, context.getUserInfo])


    const handleStartChange = (data) => {
        if (!data.value) return
        setStart(moment(data.value).startOf('month').format('YYYY-MM-DD'))
        setBuildingsInfo(null)
    }

    const handleEndChange = (data) => {
        if (!data.value) return
        setEnd(moment(data.value).endOf('month').format('YYYY-MM-DD'))
        setBuildingsInfo(null)
    }

    const handleSelectedBuilding = (e) => {
        if (e.every(item => selectedBuildings.includes(item))) {
            setSelectedBuildings(prev => prev.filter(v => !e.includes(v)))
        } else {
            setSelectedBuildings(prev => [...prev, ...e])
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmit(true)

        const getBuildings = async () => {
            try {
                const cancelToken = API.cancelToken();
                const batchSize = 3;
                const buildingsDict = {};

                for (let i = 0; i < selectedBuildings.length; i += batchSize) {
                    const batch = selectedBuildings.slice(i, i + batchSize);

                    const buildingPromises = batch.map(building =>
                        withRetry504(() => API.getBuildingUtilityBills(cancelToken, building, start, end))
                            .catch(e => {
                                console.log(`Failed to get data for building ${building.building_id}`);
                                console.log(e);
                                return { building_id: building.building_id, error: e };
                            })
                    );

                    const results = await Promise.all(buildingPromises);

                    results.forEach((result, index) => {
                        if (!result.error) {
                            result = result.data;
                            buildingsDict[result.building.building_id] = {
                                buildingInfo: result.building,
                                bills: result.bills.map(item => {
                                    let date = moment([item.bill_year, item.bill_month - 1, 1]).format("YYYY-MM-DD");
                                    let obj = {
                                        ...item,
                                        date: date,
                                        total_cost: item.basic_monthly + item.delivery_charges + item.other_charges +
                                            item.carbon_charge + item.kwh_cost + item.kva_cost +
                                            item.municipal_tax + item.gst_cost + item.pst_cost
                                    };

                                    if (item.type === 1) {
                                        obj = {
                                            ...item,
                                            date: date,
                                            total_cost: item.basic_monthly + item.delivery_charges + item.other_charges +
                                                item.carbon_charge + item.gas_cost + item.municipal_tax +
                                                item.gst_cost + item.pst_cost
                                        };
                                    } else if (item.type === 2) {
                                        obj = {
                                            ...item,
                                            date: date,
                                            total_cost: item.basic_monthly + item.delivery_charges + item.other_charges +
                                                item.carbon_charge + item.water_cost + item.sewage_cost +
                                                item.municipal_tax + item.gst_cost + item.pst_cost
                                        };
                                    }

                                    return obj;
                                }),
                            };
                        }
                    });
                }

                setBuildingsInfo(buildingsDict);
                setSubmit(false);
            } catch (e) {
                console.log("Unexpected error in getBuildings");
                console.log(e);
                setSubmit(false);
            }
        };
        getBuildings()
    }

    return (
        <div>
            <div className="laptop:px-8 tablet:px-4 mobile:px-4 py-2 flex flex-nowrap justify-between items-center rounded-md bg-[#FFF] shadow-md" >
                <div className='flex flex-nowrap gap-6 text-base font-bold'>
                    {
                        context.getBuildingInfo && context.getBuildingInfo.bills_only ?
                            <span className='text-[gray]'>Buildings</span>
                            :
                            <Link to={`/reports?building=all`}>Buildings</Link>
                    }
                    {
                        context.getBuildingInfo && context.getBuildingInfo.bills_only ?
                            <span className='text-[gray]'>Portfolio</span>
                            :
                            <Link to={`/report`} className=''>Portfolio</Link>
                    }
                    <Link to={`/billreports`} className='active-reports-tab'>Bills</Link>
                </div>
                <div className='flex flex-nowrap justify-end items-center w-9/12'>
                    {!context.getLaptop &&
                        <div className="flex flex-norap justify-end items-center">
                            <div className='flex justify-end items-center m-2'>
                                <div>
                                    <div className={`mr-0 flex justify-start items-center`}>
                                        <div className={`flex justify-end leading-5 mr-5 items-center`}>
                                            <p className="font-sans font-normal text-sans text-[#332D41] md:decoration-dashed text-[14px]">Select Range:</p>
                                        </div>
                                        <div className={`flex justify-start gap-5`}>
                                            <DatePickerComponent start="Year" depth="Year" format="MMM yyyy" onChange={handleStartChange} placeholder='Start Month' />
                                            <DatePickerComponent start="Year" depth="Year" format="MMM yyyy" onChange={handleEndChange} placeholder='End Month' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <AccordionMultipleSelect
                                placeholder="Select Buildings"
                                dataType="buildingId"
                                idAttr="building_id"
                                valAttr="building"
                                selectItem={handleSelectedBuilding}
                                data={buildingOptions}
                                selectedList={selectedBuildings}
                                deselectAll={true}
                            />
                        </div>
                    }
                    {!context.getLaptop && start && end && selectedBuildings.length > 0 && !submit &&
                        <button onClick={handleSubmit} className='submit-button ml-2'>Generate Report</button>
                    }
                </div>
            </div >

            {buildingsInfo &&
                <div className='tablet:px-12 mobile:p-3'>
                    <UtilityBillGraph1
                        buildings={buildingsInfo}
                        startEnd={[start, end]}
                    />
                </div>}
            {buildingsInfo &&
                <div className='tablet:px-12 mobile:p-3 mb-8'>
                    <UtilityBillGraph2
                        buildings={buildingsInfo}
                        startEnd={[start, end]}
                    />
                </div>}
            {submit &&
                <div className='h-[70vh]'>
                    <p className='pt-8 text-center text-[#C1C1C1]'>Generating your report. This might take a few minutes...</p>
                    <Loader />
                </div>
            }
        </div>
    );
};

export default UtilityReport;